<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="search-container">
          <el-input
            v-model="listQuery.keyword"
            class="search-input"
            placeholder="Order Number"
            prefix-icon="el-icon-search"
            size="mini"
            clearable
          />
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            circle
            @click="applyKeywordSearch"
          />
        </div>
      </div>
    </template>
    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="ID"
        width="50"
      />
      <el-table-column
        prop="member_name"
        label="Memeber Name"
        min-width="150"
      />
      <el-table-column
        prop="merchant_name"
        label="Merchant Name"
        min-width="150"
      />
      <el-table-column
        prop="order_number"
        label="Order Number"
        min-width="120"
      />
      <el-table-column
        prop="refund_type"
        label="Refund Type"
        min-width="100"
      />
      <el-table-column
        prop="reason_name"
        label="Reason"
        min-width="150"
      />
      <el-table-column
        prop="confirm_status"
        label="Confirm Status"
        min-width="120"
      />
      <el-table-column
        prop="validate_status"
        label="Validate Status"
        min-width="120"
      />
      <el-table-column
        prop="refund_status"
        label="Refund Status"
        min-width="120"
      />
      <el-table-column
        label="Detail"
        fixed="right"
        align="center"
        width="60"
      >
        <template #default="{ row }">
          <edit-button
            @click="handleDetailClicked(row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :disabled="isLoading"
        :current-page="listQuery.page"
        :page-sizes="listQuery.sizes"
        :page-size="listQuery.size"
        :total="listQuery.total"
        background
        layout="total, sizes, pager, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </div>
    <el-dialog
      v-loading="isFetchingRefundDetail"
      :visible.sync="isRefundDialogOpen"
      :close-on-click-modal="!isRefundDialogDisabled"
      :close-on-press-escape="!isRefundDialogDisabled"
      :before-close="closeRefundDialog"
      :show-close="false"
      title="Refund Detail"
      width="50%"
      top="6vh"
    >
      <div>
        <strong>Order Number: </strong>
        {{ dialog.orderNumber }}
      </div>
      <div>
        <strong>Merchant: </strong>
        {{ dialog.merchantName }}
      </div>
      <div>
        <strong>Remarks: </strong>
        {{ dialog.remarks }}
      </div>
      <el-button
        v-if="isShowFullRefundButton"
        type="primary"
        class="mt-2 mx-0"
        @click="confirmFullRefund"
      >
        {{ confirmFullRefundButtonLabel }}
      </el-button>
      <template v-if="dialog.data">
        <div
          v-for="item of dialog.data"
          :key="item"
          class="merchant-detail-wrapper"
          >
            <label-wrapper
              :key="item"
              lable="product"
              class="pt-2"
            >
              <p><strong>Product Name: </strong>{{ item.order_product_name }}</p>
              <p><strong>Product Variant: </strong>{{ item.order_variant_name }}</p>
              <p><strong>Quantity: </strong>{{ item.quantity }}</p>
              <div>
                <el-button
                  v-if="isShowPartialRefundButton"
                  type="primary"
                  class="mt-2 mx-0"
                  :style="{ 'position': 'relative', 'float': 'right'}"
                  @click="confirmPartialRefund"
                >
                  {{ confirmPartialRefundButtonLabel }}
                </el-button>
              </div>
            </label-wrapper>
        </div>
      </template>
      <div 
        v-if="dialog.refundResult"
        class="mt-2 mx-0"
      >
        <div>
          <strong>Refund Result: </strong>
        </div>
        <div v-for="item of dialog.refundResult">
          <div>
            <strong>Order Number: </strong>
            {{ item.order_number }}
          </div>
          <div>
            <strong>Type: </strong>
            {{ item.type }}
          </div>
          <div>
            <strong>Currency: </strong>
            {{ item.currency.toUpperCase() }}
          </div>
          <div>
            <strong>Amount: </strong>
            {{ item.amount / 100.0 }}
          </div>
          <hr/>
        </div>
        <div>
          <el-button
            type="primary"
            class="mt-2 mx-0"
            @click="closeRefundDialog"
          >
            Close
          </el-button>
        </div>
      </div>
    </el-dialog>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'
import MarketplaceService from '../../api/marketplace'
import EditButton from '../../components/buttons/EditButton.vue'
import LabelWrapper from '../../components/form/LabelWrapper.vue'
import store from '../../store'

export default {
  name: 'RefundList',
  mixins: [useTablePaging],
  components: {
    EditButton,
    LabelWrapper,
  },
  data() {
    return {
      filter: {
        store_id: '',
        advertiser_id: '',
      },
      isFetchingRefundDetail: false,
      isRefundDialogOpen: false,
      isLoading: false,
      selectedId: 0,
      selectedOrderNumber: '',
      selectedRefundRequest: null,
      dialog: {
        orderNumber: null,
        merchantName: null,
        remarks: null,
        data: null,
        refundResult: null,
      },
    }
  },
  computed: {
    isRootAdmin() {
      return (store.getters['user/id'] === 1)
    },
    isRefundDialogDisabled() {
      return this.isFetchingRefundDetail || this.isLoading
    },
    confirmFullRefundButtonLabel() {
      return (this.isRootAdmin) ? this.$t('button.confirmFullRefund') : this.$t('button.validateFullRefund')
    },
    confirmPartialRefundButtonLabel() {
      return (this.isRootAdmin) ? this.$t('button.confirmPartialRefund') : this.$t('button.validateRefund')
    },
    isShowFullRefundButton() {
      if (this.selectedRefundRequest && this.selectedRefundRequest.refund_type == 'full') {
        if (this.isRootAdmin) {
          return (this.selectedRefundRequest.refund_status == 'Open')
        } else {
          return (this.selectedRefundRequest.validate_status == 'Open')
        }
      }

      return false
    },
    isShowPartialRefundButton() {
      if (this.selectedRefundRequest && this.selectedRefundRequest.refund_type == 'partial') {
        if (this.isRootAdmin) {
          return (this.selectedRefundRequest.refund_status == 'Open')
        } else {
          return (this.selectedRefundRequest.validate_status == 'Open')
        }
      }

      return false
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await MarketplaceService.getRefundlist(this.listQuery.keyword)
        this.list = response.data
        this.listQuery.total = +response.pagination.total_items

        const statusLabels = ['Open', 'Confirmed', 'Partially confirmed', 'Rejected']

        for (const item of this.list) {
          if (item.confirm_status >= 0 && item.confirm_status < statusLabels.length) {
            item.confirm_status = statusLabels[item.confirm_status]
          }

          if (item.validate_status >= 0 && item.validate_status < statusLabels.length) {
            item.validate_status = statusLabels[item.validate_status]
          }

          if (item.refund_status >= 0 && item.refund_status < statusLabels.length) {
            item.refund_status = statusLabels[item.refund_status]
          }
        }

        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    async confirmFullRefund() {
      if (this.isRootAdmin) {
        const response = await MarketplaceService.confirmFullRefund(this.selectedId)
        this.dialog.refundResult = [response.data]
      } else {
        await MarketplaceService.validateFullRefund(this.selectedId, 'accept')
        this.closeRefundDialog()
      }
    },
    async confirmPartialRefund() {
      if (this.isRootAdmin) {
        const response = await MarketplaceService.confirmPartialRefund(this.selectedId)
        this.dialog.refundResult = response.data
      } else {
        await MarketplaceService.validatePartialRefund(this.selectedId, 'accept')
        this.closeRefundDialog()
      }
    },
    applyKeywordSearch() {
      this.getList()
    },
    handleDetailClicked(row) {
      this.openRefundDialog(row)
    },
    openRefundDialog(row) {
      this.selectedId = row.id
      this.selectedOrderNumber = row.order_number
      this.selectedRefundRequest = row
      this.dialog.data = row.items
      this.dialog.orderNumber = row.order_number
      this.dialog.merchantName = row.merchant_name
      this.dialog.remarks = (row.remarks && row.remarks.length > 0) ? row.remarks : 'N/A'
      this.dialog.refundResult = null
      this.isRefundDialogOpen = true
    },
    closeRefundDialog() {
      this.isRefundDialogOpen = false
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
.search-container {
  display:flex;
  .search-input {
    width: 200px;
    margin-right: 10px;
  }
  button {
    margin: 0 5px;
  }
}
.pagination-container {
  padding: 10px 0;
}

.merchant-detail-wrapper {
  display: flex;
  flex-wrap: wrap;

  > * {
    flex: 1;
    flex-basis: calc(50% - 32px);
    // max-width: calc(50% - 32px);
    border-bottom: 1px solid #e7e7e7;
    margin: 1px 16px;
    padding-bottom: 10px;
  }
}
</style>

